import LeerpoortIcon from '@pelckmans/elementis/icons/leerpoort';
import PelckmansIcon from '@pelckmans/elementis/icons/pelckmans';
import useStudioGroup from '../hooks/useStudioGroup';

export default function BrandIcon(props: React.SVGProps<SVGSVGElement>) {
  const studioGroup = useStudioGroup();
  return studioGroup === 'BAO' ? (
    <LeerpoortIcon {...props} data-testid="leerpoort-icon" />
  ) : (
    <PelckmansIcon {...props} data-testid="pelckmans-icon" />
  );
}
